import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _getRestaurantLocationRequest = {};
var _getRestaurantLocationResponse = {
    restaurantLocation: '_restaurantLocation',
};
var _listRestaurantLocationsRequest = {};
var _listRestaurantLocationsResponse = {
    restaurantLocations: '_restaurantLocation',
};
var _location = { address: '_address' };
var _restaurantLocation = { location: '_location' };
function resolveComWixpressRestaurantsRestaurantlocationsV3RestaurantLocationsServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
            {
                srcPath: '/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
            {
                srcPath: '/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants/v3/restaurant-locations',
                destPath: '/v3/restaurant-locations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get a RestaurantLocation by id */
export function getRestaurantLocation(payload) {
    var _a = serializer(_getRestaurantLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRestaurantLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _restaurantLocation: _restaurantLocation,
    }).fromJSON;
    function __getRestaurantLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.restaurantlocations.v3.restaurant_location',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.restaurantlocations.v3.RestaurantLocationsService.GetRestaurantLocation',
            url: resolveComWixpressRestaurantsRestaurantlocationsV3RestaurantLocationsServiceUrl({
                protoPath: '/v3/restaurant-locations/{restaurantLocationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRestaurantLocation.fromReq = fromReq;
    __getRestaurantLocation.__isAmbassador = true;
    return __getRestaurantLocation;
}
/** Get Restaurant locations */
export function listRestaurantLocations(payload) {
    var _a = serializer(_listRestaurantLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRestaurantLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _restaurantLocation: _restaurantLocation,
    }).fromJSON;
    function __listRestaurantLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.restaurantlocations.v3.restaurant_location',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.restaurantlocations.v3.RestaurantLocationsService.ListRestaurantLocations',
            url: resolveComWixpressRestaurantsRestaurantlocationsV3RestaurantLocationsServiceUrl({ protoPath: '/v3/restaurant-locations', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRestaurantLocations.fromReq = fromReq;
    __listRestaurantLocations.__isAmbassador = true;
    return __listRestaurantLocations;
}
//# sourceMappingURL=http.impl.js.map